// extracted by mini-css-extract-plugin
module.exports = {"sidebar-title":"sidebar_sidebar-title__1MJPk"};